import React from 'react'
import handimg from '../Assets/handimg.png'
import handimg1 from '../Assets/handimg1.png'
function About() {
  return (
    <>
   
   <div class="flex flex-col xl:flex-row-reverse items-center justify-center gap-8 px-4 sm:px-6 lg:px-10 py-8 lg:mt-12 lg:mb-[50px]">

  {/* Section 1 */}
  <div class="max-w-lg w-full bg-white md:max-w-2xl md:z-10 shadow-lg mt-5 lg:mt-10">
    <div class="flex flex-col p-4 sm:p-8 md:px-12 font-serif">
      <h2 class="text-2xl font-medium lg:text-4xl">Our Expertise</h2>
      <p class="mt-4 text-sm sm:text-base">
        At Bulk SMS Nagpur, we also specialize in professional Website Designing services, offering both static and dynamic website solutions tailored to meet your business needs. Our expert team ensures your website is visually appealing, responsive, and user-friendly, enhancing your brand's digital presence.
        <br /><br />
        Additionally, we provide comprehensive Domain Registration and reliable Web Hosting services, complete with SSL certificates for secure and trustworthy websites. Whether you're looking to establish a simple online presence or require a complex dynamic platform, we are here to deliver innovative and scalable solutions that help your business grow online.
      </p>
    </div>
  </div>

  {/* Image for large screens */}
  <div class="hidden xl:block">
    <img
      class="object-contain w-full max-w-[300px] sm:max-w-[400px] lg:max-w-[500px] h-auto"
      src={handimg}
      alt="handimg1"
    />
  </div>

  {/* Image for small screens */}
  <div class="block xl:hidden">
    <img
      class="object-contain w-full max-w-[300px] sm:max-w-[400px] h-auto"
      src={handimg1}
      alt="handimg2"
    />
  </div>

  {/* Section 2 */}
  <div class="max-w-lg w-full bg-white md:max-w-2xl md:z-10 shadow-lg mt-5">
    <div class="flex flex-col p-4 sm:p-8 md:px-12 font-serif">
      <h2 class="text-2xl font-medium lg:text-4xl">About Us</h2>
      <p class="mt-4 text-sm sm:text-base">
        Bulk SMS Nagpur is a leading Bulk SMS Company with wireless application service offering two-way SMS messaging services. We have a wide-ranging experience of more than 14 years in online advertising, search engine marketing, and promotions through new media technologies.
        We have expertise in utilizing emerging technologies like mobile & internet for communication processes, business organization, branding & marketing.
        <br /><br />
        We provide you with an easy-to-use Bulk SMS communication tool that helps you send Bulk SMS to multiple users at a single stroke. By using our SMS service, you can reach maximum people in a minute. We provide many options through which a user can avail SMS-related services like Push SMS, 2-way SMS, Voice SMS, Flash SMS, and Picture SMS with Instant Delivery, Scheduling, Dynamic Sender ID, Long Code/Short Code, SMS Marketing & Campaign.
        <br /><br />
        Read more &#8594;
      </p>
    </div>
  </div>
</div>


    </>
  )
}

export default About